import { Action } from '@reduxjs/toolkit';

import type { FreeBet } from 'app/api/services/freebets/types';
import type { ReduxAction } from 'app/redux/types';

import type { ExpressMatchPrices } from '../../types/stakeTypes/express';

// ---

export const REFRESH_MATCH_PRICES = 'BET_SLIP:REFRESH_MATCH_PRICES';

export type RefreshMatchPrices = ReduxAction<
  typeof REFRESH_MATCH_PRICES,
  ExpressMatchPrices
>;

export const refreshMatchPrices = (payload: ExpressMatchPrices): RefreshMatchPrices => ({
  type: REFRESH_MATCH_PRICES,
  payload,
});

// ---

export const SET_EXPRESS_FREE_BET = 'BET_SLIP:SET_EXPRESS_FREE_BET';

export type SetExpressFreeBet = ReduxAction<typeof SET_EXPRESS_FREE_BET, {
  entry: FreeBet;
}>;

export const setExpressFreeBet = (entry: FreeBet): SetExpressFreeBet => ({
  type: SET_EXPRESS_FREE_BET,
  payload: { entry },
});

// ---

export const REMOVE_EXPRESS_FREE_BET = 'BET_SLIP:REMOVE_EXPRESS_FREE_BET';

export type RemoveExpressFreeBet = Action<typeof REMOVE_EXPRESS_FREE_BET>;

export const removeExpressFreeBet = (): RemoveExpressFreeBet => ({
  type: REMOVE_EXPRESS_FREE_BET,
});
